
import firebase from 'firebase/app';
import 'firebase/functions';

const REGION_TOKYO = "asia-northeast1";

const sendGrid =async (payload) => {
  const sendMail = firebase.app()
      .functions(REGION_TOKYO) // Functionsのデプロイされているregion指定
      .httpsCallable("sendMail"); // Functionsの関数名指定
    const result = await sendMail(payload);
    return result;
};
export default sendGrid
